module.exports = __webpack_public_path__ + "static/ogp-services-a8a156f7a87025086c2c17cb3dea2105.png";